import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'core-helpers-disconnected-ribbon-button',
    templateUrl: './disconnected-ribbon.component.html',
    styleUrls: ['./disconnected-ribbon.component.scss']
})
export class HelperBoxDisconnectedRibbonComponent {

    reload() {
        window.location.reload();
    }
}
